import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { propTypes } from '../../../util/types';
import { FormattedMessage } from '../../../util/reactIntl';
import TopbarSearchForm from '../../TopbarContainer/Topbar/TopbarSearchForm/TopbarSearchForm';

import heroImageFirst from '../images/hero-img-1.png';
import heroImageSecond from '../images/hero-img-2.png';
import css from './SectionHero.module.css';

const SectionHero = props => {
  const {
    className,
    rootClassName,
    onFetchTopbarListings,
    fetchTopbarListingsInProgress,
    fetchTopbarListingsError,
    topbarListings,
    totalListingsCount,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const onSearchSubmit = () => {
    return;
  };

  return (
    <div className={classes}>
      <div className={css.content}>
        <h1 className={css.title}>
          <FormattedMessage id="LandingPage.SectionHero.title" />
        </h1>
        <p className={css.text}>
          <FormattedMessage id="LandingPage.SectionHero.text" />
        </p>
        <TopbarSearchForm
          className={css.searchForm}
          inputClassName={css.searchFormInput}
          inputRootClassName={css.searchFormInputRoot}
          predictionsClassName={css.searchFormPredictions}
          onSubmit={onSearchSubmit}
          onFetchTopbarListings={onFetchTopbarListings}
          fetchTopbarListingsInProgress={fetchTopbarListingsInProgress}
          fetchTopbarListingsError={fetchTopbarListingsError}
          topbarListings={topbarListings}
          totalListingsCount={totalListingsCount}
        />
      </div>
      <div className={css.heroImages}>
        <img src={heroImageFirst} className={css.heroImage} alt="Alt" />
        <img src={heroImageSecond} className={css.heroImage} alt="Alt" />
      </div>
    </div>
  );
};

const { string, bool, func, arrayOf, number } = PropTypes;

SectionHero.defaultProps = {
  className: null,
  rootClassName: null,
  fetchTopbarListingsInProgress: false,
  fetchTopbarListingsError: null,
};

SectionHero.propTypes = {
  className: string,
  rootClassName: string,
  onFetchTopbarListings: func.isRequired,
  fetchTopbarListingsInProgress: bool.isRequired,
  fetchTopbarListingsError: propTypes.error,
  topbarListings: arrayOf(propTypes.listing),
  totalListingsCount: number,
};

export default SectionHero;
